export default __webpack_public_path__ + "static/media/lock-icon.ccfd1388.svg";